import CollapsableForm from './CollapsableForm';
import CollapsableFormSection from './CollapseFormSection';

CollapsableForm.Section = CollapsableFormSection;

export default CollapsableForm;
